import React, { Component } from 'react';
import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';
import styles from './index.module.css';
import bachelorUser from '@assets/ChatFeature/bachelorUser.png';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class VideoSuggestionMessage extends Component {
  render() {
    const { t, onClickVideoMessage, isWhiteMode } = this.props;

    return (
      <span className={styles.partnerTextMessage}>
        <div
          className={classNames(styles.chatPartnerTextBubble, {
            [styles.textBlack]: isWhiteMode
          })}
        >
          <img alt="" src={bachelorUser} className={styles.chatUserIcon} />
          <div className={styles.chatTextWrapper}>
            <div className={styles.text}>
              {t('chat-video-message-suggestion-1')}
            </div>
            <div className={styles.text}>
              {t('chat-video-message-suggestion-2')}
            </div>
            <div className={classNames([styles.text, styles.textBottom])}>
              {t('chat-video-message-suggestion-3')}
              <span
                className={styles.chatLinkText}
                onClick={onClickVideoMessage}
              >
                {t('chat-video-message-suggestion-4')}
              </span>
            </div>
          </div>
        </div>
        <span className={styles.textNote}>
          {t('message-not-display-to-other-partner')}
        </span>
      </span>
    );
  }
}

VideoSuggestionMessage.propTypes = {
  onClickVideoMessage: PropTypes.func,
  isWhiteMode: PropTypes.bool
}
export default compose(withNamespaces('chat', { wait: true }))(
  VideoSuggestionMessage
);
